// One-shot scroll of the calendar container to the computed now-line position.
import { useEffect, useRef } from 'react';

const SCROLL_DELAY_MS = 100;

export default function useCalendarAutoScroll(
  calendarContainerRef,
  scrollPosition,
  scrollBehavior,
  resetKey,
) {
  const hasScrolled = useRef(false);

  useEffect(() => {
    hasScrolled.current = false;
  }, [resetKey]);

  useEffect(() => {
    if (
      scrollPosition !== -1 &&
      !hasScrolled.current &&
      calendarContainerRef.current
    ) {
      const timer = setTimeout(() => {
        if (calendarContainerRef.current) {
          calendarContainerRef.current.scrollTo({
            top: scrollPosition,
            behavior: scrollBehavior,
          });
          hasScrolled.current = true;
        }
      }, SCROLL_DELAY_MS);

      return () => clearTimeout(timer);
    }
  }, [calendarContainerRef, scrollPosition, scrollBehavior]);
}
